export const getDiscourseChatUrl = (): string => {
  const configuredChatUrl = import.meta.env.VITE_DISCOURSE_CHAT_URL as string | undefined;
  const discourseUrl = (import.meta.env.VITE_DISCOURSE_URL as string | undefined)?.replace(/\/+$/, '');

  return configuredChatUrl || (discourseUrl ? `${discourseUrl}/chat` : '');
};

export const getDiscourseActivationUrl = (): string => {
  const chatUrl = getDiscourseChatUrl();
  const configuredDiscourseUrl = import.meta.env.VITE_DISCOURSE_URL as string | undefined;

  if (!chatUrl) {
    return '';
  }

  try {
    const discourseUrl = new URL(configuredDiscourseUrl || chatUrl);
    const destinationUrl = new URL(chatUrl, discourseUrl);

    if (destinationUrl.origin !== discourseUrl.origin) {
      return chatUrl;
    }

    const activationUrl = new URL(discourseUrl);
    const discourseBasePath = discourseUrl.pathname.replace(/\/+$/, '');
    activationUrl.pathname = `${discourseBasePath}/session/sso`;
    activationUrl.search = '';
    activationUrl.hash = '';
    activationUrl.searchParams.set(
      'return_path',
      `${destinationUrl.pathname}${destinationUrl.search}${destinationUrl.hash}`
    );

    return activationUrl.toString();
  } catch {
    return chatUrl;
  }
};
